module.exports = __webpack_public_path__ + "img/gn.7de80736.svg";